import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { requestPasswordReset } from '../../../../../helpers/auth-helper';
import { finishLoading, setError, startLoading, unsetError } from '../../../../../actions/ui';
import { AuthLayout } from '../AuthLayout'

export const RecoveryPassword = () => {

    const dispatch = useDispatch();
    const { error, loading } = useSelector(state => state.ui);
    const [ email, setEmail ] = useState('');
    const [ successMessage, setSuccessMessage ] = useState(null);

    const handleInputChange = ({ target }) => {
        setEmail(target.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        dispatch(unsetError());
        dispatch(startLoading());

        const resp = await requestPasswordReset(email);

        if (resp.success) {
            setSuccessMessage(resp.message);
            setEmail('');
        } else {
            dispatch(setError(resp.message));
        }

        dispatch(finishLoading());
    }

    return (
        <AuthLayout>
            <div className="card mb-4 mt-5 mx-4 mx-sm-0 position-relative">
                <div className="wd-50 bg-white p-2 rounded-circle shadow-lg position-absolute translate-middle top-0 start-50">
                    <img src="/assets/logo/logo-abbr.png" alt="" className="img-fluid" />
                </div>
                <div className="card-body p-sm-5">
                    <h2 className="fs-20 fw-bolder mb-4">Recuperar contraseña</h2>
                    <h4 className="fs-13 fw-bold mb-2">Recupera tu contraseña</h4>
                    <p className="fs-12 fw-medium text-muted">Ingresa tu correo electrónico y se te enviará un enlace de recuperación.</p>

                    {error && (
                        <div className="alert alert-danger mt-3" role="alert">
                            {error}
                        </div>
                    )}

                    {successMessage && (
                        <div className="alert alert-success mt-3" role="alert">
                            {successMessage}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="w-100 mt-4 pt-2">
                        {
                            !successMessage && (
                                <div className="mb-4">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Correo electrónico"
                                        value={email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                            )
                        }
                        {
                            !successMessage && (
                                <div className="mt-5">
                                    <button type="submit" className="btn btn-lg btn-primary w-100" disabled={loading}>Restablecer ahora</button>
                                </div>
                            )
                        }
                    </form>
                    <div className="mt-5 text-muted">
                        <span> ¿No tienes una cuenta?</span> <a href="/auth/register" className="fw-bold">Crea una cuenta</a>
                    </div>
                </div>
            </div>
        </AuthLayout>
    )
}
